import EmptyState from '@components/EmptyState'
import React from 'react'

const ActiveLiveCoaching: React.FC = () => (
  <EmptyState
    heading="You currently have a Live coaching session booked. Book your next session after completion."
    img="/images/single-session-booked.svg"
    linkUrl="/learning-path"
    btnTxt="Go to my Learning Path"
    top="md"
  />
)

export default ActiveLiveCoaching
